import { defineTheme } from '../utils'

export const valentine = defineTheme({
  themeLogo: {
    image: 'hidden',
  },
  menuTitleBlock: {
    title: 'text-5xl font-bold uppercase md:text-7xl',
  },
  menuItem: {
    dinner: {
      title: 'mr-2 inline font-bold uppercase',
      base: 'after:text-4xl after:text-secondary after:opacity-33 after:content-["♥_♥_♥_♥_♥_♥_♥_♥"]',
      priceList: 'inline-flex',
      icons: 'ml-2 inline-flex',
    },
    drinks: {
      title: 'mr-2 inline font-bold uppercase',
      base: 'after:text-4xl after:text-secondary after:opacity-33 after:content-["♥_♥_♥_♥_♥_♥_♥_♥"]',
      priceList: 'inline-flex',
      icons: 'ml-2 inline-flex',
    },
  },
  page: {
    heading: 'text-5xl font-bold uppercase md:text-7xl',
  },
  languageButton: {
    base: 'hover: w-full rounded border-2 border-white bg-white/30 px-4 py-3 text-center text-white hover:opacity-75',
  },
  filterBar: {
    bar: 'bg-primary text-secondary',
    checkbox: ' accent-secondary',
    closeButton: 'bg-white text-secondary hover:bg-white/80',
    masterItem: 'text-black',
    itemLabel: 'text-secondary',
    popoverTitle: 'text-white',
    popover: 'bg-white',
    popoverHeader: 'bg-secondary',
  },
})
